import util from '@bmp-vue/core/api/util'
import * as XLSX from 'xlsx';

const controller = 'Exportacao'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GerarExcel: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarExcel', dto)
  },
  ExportToExcel (th, data, schema, fileName = 'export.xlsx') {
    const headers = schema.map((col) => col.text);
    const formattedData = data.map((row) => {
      const formattedRow = {};
      schema.forEach(({ value, format }) => {
        let cellValue = row[value];
        if (format) {
          if (format === 'date') {
            cellValue = th.$api.UI.Format.Date(cellValue)
          } else if (format === 'documento') {
            cellValue = th.$api.UI.Format.DocumentoFederal(cellValue)
          }
        }
        formattedRow[value] = cellValue;
      });
      return formattedRow;
    });
    const excelData = [headers];
    formattedData.forEach((row) => {
      const rowData = schema.map((col) => row[col.value] || '');
      excelData.push(rowData);
    });
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
    XLSX.writeFile(workbook, fileName);
  },
  RelatorioCompleto (th, e, dto, customFilter) {
    const schema = [
      { text: 'Proposta', value: 'CodigoProposta' },
      { text: 'Data da Criação', value: 'DtInclusao', format: 'date' },
      { text: 'Hora', value: 'Hora', format: 'time' },
      { text: 'Cliente', value: 'ClienteNome' },
      { text: 'E-mail', value: 'Email' },
      { text: 'Telefone celular', value: 'TelefoneCelular1' },
      { text: 'Rua', value: 'Logradouro' },
      { text: 'Número', value: 'NroLogradouro' },
      { text: 'Complemento', value: 'Complemento' },
      { text: 'Bairro', value: 'Bairro' },
      { text: 'Cidade', value: 'Cidade' },
      { text: 'Estado', value: 'UF' },
      { text: 'CEP', value: 'CEP', format: 'cep' },
      { text: 'Documento Federal', value: 'ClienteDocumentoFederal', format: 'documento' },
      { text: 'Tipo de Pessoa', value: 'TipoPessoa' },
      { text: 'Vendedor', value: 'NomeVendedor' },
      { text: 'Parcelas Solicitadas', value: 'QtdeParcelasSolicitado' },
      { text: 'Parcelas Aprovadas', value: 'QtdeParcelas' },
      { text: 'Valor Solicitado', value: 'VlrSolicitado', },
      { text: 'Valor Aprovado', value: 'VlrFinanciado', },
      { text: 'Situação', value: 'Situacao' },
    ]
    if (!customFilter) {
      if (th.$user.roles === 'Multiplo.Gerente') {
        dto.parameters.push({ name: 'FiltraGerente', value: true })
        dto.parameters.push({ name: 'EmailGerentes', values: th.emailGerentes })
        dto.parameters.push({ name: 'EmailMasters', values: th.emailMasters })
      } else if (th.$user.roles === 'Multiplo.Operador') {
        dto.parameters.push({ name: 'FiltraVendedor', value: true })
      }
    }
    th.$api.Multiplo.Post('PropostaListDetalhado', dto).then((response) => {
      if (th.$api.UI.PostLoadData(response)) {
        const data = response.Data.map((item) => ({
          ...item,
          Situacao: th.$aux.Situacao.find((p) => p.value === item.Situacao)?.text || item.Situacao,
          Hora: item.DtInclusao.split('T')[1],
          VlrSolicitado: item.VlrSolicitado,
          VlrFinanciado: item.VlrFinanciado,
          TipoPessoa: th.$api.UI.Format.SomenteAlfanumerico(item.ClienteDocumentoFederal).length === 11 ? 'FÍSICA' : 'JURÍDICA',
          TelefoneCelular1: th.$api.UI.Format.Celular(item.PessoaDadosContato?.TelefoneCelular1),
          Email: item.PessoaDadosContato?.Email,
          Logradouro: item.PessoaEndereco?.Logradouro,
          NroLogradouro: item.PessoaEndereco?.NroLogradouro,
          Complemento: item.PessoaEndereco?.Complemento,
          Bairro: item.PessoaEndereco?.Bairro,
          Cidade: item.PessoaEndereco?.Cidade,
          UF: item.PessoaEndereco?.UF,
          CEP: item.PessoaEndereco?.CEP,
        }));
        th.$api.Exportacao.ExportToExcel(th, data, schema, 'propostas.xlsx');
      }
    });
  }
})
